// Configuración de AWS Cognito y API
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_C2LVxiepO', // dev: 2_UvmWSCB4i :: prod: 1_C2LVxiepO
      userPoolClientId: '7uaigubdf1i8v6mdpt2hvq5oib',  // dev: 2rio311lk9im8593n2ll0teh5r ::  prod:7uaigubdf1i8v6mdpt2hvq5oib
      region: 'us-east-2',
    }
  },
  API: {
    REST: {
      'sunat-api': {
        endpoint: 'https://hfgp540y7g.execute-api.us-east-1.amazonaws.com/prod', //dev: https://4tum0sqo0h.execute-api.us-east-2.amazonaws.com/dev.  prod: https://hfgp540y7g.execute-api.us-east-1.amazonaws.com/prod
        region: 'us-east-1', // dev: us-east-2 :: prod: us-east-1
      }
    }
  }
};

export const API_KEY = 'eXBmByEpzq39Ri9Vn3VSxDaBfefS4Co5JkC5qi83'; // dev:BUZsB7dnl75nnAcHA06sQ5WaCvPXTRQC5SfJArnC  prod:AIzaSyBFJzOHDK7vA7pVkqSFWXMKaTUu-Qz46ew
